import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { LoginService } from '../user-login/login.service';
import { Router } from '@angular/router';
import { CustomerService } from '../customer/customer.service';
import { ModeratorService } from '../moderator/moderator.service';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.css'],
    standalone: false
})
export class MainNavComponent implements OnInit {
  userDetails;
  authStatus;
  role='';
  isHandset$: Observable<boolean>;
  toggle: boolean = false;
  balance;
  unverifiedMessages
  unverifiedMessagesCount
  constructor(private breakpointObserver: BreakpointObserver, private loginService: LoginService, private router: Router, private customerService: CustomerService, private moderatorService: ModeratorService) {
    this.balance = JSON.parse(localStorage.getItem('balance'))
    if(!this.balance){
    this.customerService.balanceEmitter.subscribe(
      balance=>{
        this.balance = balance
       //console.log('got balance', balance)
      })};
      
  }

  ngOnInit(){
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.authStatus = true;
          this.userDetails = res['user'];
          this.role = this.userDetails.role;
          console.log('NavBar stuff', this.userDetails, this.role);
          if(this.role === 'MODERATOR'){
            // console.log('MODERATOR', this.role)
            this.getUnverifiedMessageCountsForModerator()
          }
        },
        err => {
         //console.log(err);
        }
        );
    }
  }

  logout(){
    this.role='';
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }

  getUnverifiedMessageCountsForModerator(){
    this.moderatorService.getUnverifiedMessageCounts().subscribe(
      res => {
        // console.log('got res', res)
        this.unverifiedMessages = res
        this.unverifiedMessagesCount = this.unverifiedMessages['length']
        console.log('unverifiedMessages', this.unverifiedMessages, this.unverifiedMessages['length'])
      },
      err =>{
        console.log('error', err)
      }
    )
  }
}
